import { differenceInCalendarDays, differenceInMinutes } from 'date-fns'

export type TimeDifference =
  | { days: number }
  | { hours: number; minutes: number }
  | { hours: number }
  | { minutes: number }

export const getTimeDifference = (date1: Date, date2: Date): TimeDifference => {
  const days = differenceInCalendarDays(date2, date1)
  if (days > 1) return { days }

  const minuteDifference = differenceInMinutes(date2, date1)
  const hours = Math.floor(minuteDifference / 60)
  const minutes = minuteDifference % 60

  if (hours) {
    if (minutes) return { hours, minutes }
    return { hours }
  }

  return { minutes }
}
